import { action } from 'satcheljs/lib/legacy';
export default action('switchToReadWriteRecipient')(function switchToReadWriteRecipient(viewState) {
    viewState.showCompactRecipientWell = false;
});
//# sourceMappingURL=switchToReadWriteRecipient.js.map